import React from 'react'
import BarraSupDent from '../../commons/BarraSupDent'
import Title from '../Login/Components/title/title'
import '../Location/Location.css'
import InfoLocation from './Components/InfoLocation'
import NavbarDownConsumer from '../../commons/NavbarDownConsumer'



class Location extends React.Component {
    // fake authentication Promise
    authenticate(){
        return new Promise(resolve => setTimeout(resolve, 2000)) // 2 seconds
      }
    
      componentDidMount(){
        this.authenticate().then(() => {
          const ele = document.getElementById('ipl-progress-indicator')
          if(ele){
            // fade out
            ele.classList.add('available')
            setTimeout(() => {
              // remove from DOM
              ele.outerHTML = ''
            }, 2000)
          }
        })
      }

    render() {
      
    return(
        <div>
            <BarraSupDent />
            <Title text1 = "Where would you like us to meet you?" />
            <InfoLocation />
            <NavbarDownConsumer />
           
        </div> 
    )
}
}

export default Location